const typographyFormServiceQuesList = {
  itensVerifLabel: 'CHECKLIST ITENS DE VERIFICAÇÃO'
};

export default typographyFormServiceQuesList;
